export const textCodes = {
    
    copyRight: {
        code: "${merchantId}_tmpl_text_19",
        text: " - All right reserved by Asteria - Local Brand Myanmar"
    },
}